<template>
    <div style="padding:12px">
         <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
          <el-button @click="jumpToPage('schoolEdit', {schoolId})" v-if="isShowByPermission('/wyms/school/updateSchool')" type="primary" size="medium">编辑</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div class="left-panel">
                <div class="title">权限设置</div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolModuleRolePermission/schoolModuleRolePermissionList', {schoolId})">应用角色权限配置</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolRole/schoolRoleList', {schoolId})">角色用户</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolAppManage/schoolAppList', {schoolId})">应用管理</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolAdmin', {schoolId, isExternalContact: detail.isExternalContact})">学校负责人</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolPermission', {schoolId})">权限管理</el-button>
                </div>

                <div class="title">初始化设置</div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium"
                               @click="initOutsideSchoolUserDepartFunc()">初始化校外部门
                    </el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="initSchoolFellowDepartFunc()">
                        初始化校友部门
                    </el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="initNewGradeAndClassFunc()">初始化新生班级</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="initDepartCodeFunc()">初始化班级编码</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="restNoSetPasswordUserFunc()">初始化学生登录密码</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="updatePlatformTeacherFunc()">从政务读取老师数据</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <a :href="exportUrl" target="_blank" download="与政务对比教师数据">
                        <el-button style="width: 160px;" type="primary" size="medium">与政务对比教师数据</el-button>
                    </a>

                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('promoteGrade', {schoolId, schoolName: detail.name, schoolType: detail.type, upGradeStatus: detail.upGradeStatus})">升年级</el-button>
                </div>
                <div class="left-panel-btn-item" v-if="detail.clientType == 1 || detail.clientType == 12">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('activationcode', {schoolId:schoolId})">激活码同步</el-button>
                </div>

                <!-- <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolIntGrant', {schoolId, schoolName: detail.name, schoolType: detail.type, upGradeStatus: detail.upGradeStatus, corpId: detail.corpId})">接口授权</el-button>
                </div> -->
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="transStandardGradeFunc">转为标准年级</el-button>
                </div>
                 <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="dialogImportTeacherVisible=true">批量删除账号</el-button>
                </div>
                <div class="title">数据对接</div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click.native="isShowTxSch = true">与腾讯智慧校园对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium">与政务产品版对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click.native="isShowJD = true">与焦点对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click.native="isShowHaikang = true">与海康对接</el-button>
                </div>
                 <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click.native="isShowyufan = true">与宇泛对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click.native="isShowkedaxunfei = true">与科大讯飞对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" @click.native="synchSchUserList('xn')" size="medium">与乐牛对接</el-button>
                </div>
                 <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" @click.native="synchSchUserList('xn3')" size="medium">与乐牛3.0版对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" @click.native="synchSchUserList('ald')" size="medium">与爱立德对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" @click.native="jumpToPage('externalContact', {schoolId})" size="medium">新家校对接</el-button>
                </div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" @click.native="updateSysn()" size="medium">批量同步到农行</el-button>
                </div>
                 <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" @click.native="updateSysnCancel()" size="medium">取消农行同步</el-button>
                </div>
                <div class="title">数据分析</div>
                <div class="left-panel-btn-item">
                    <el-button style="width: 160px;" type="primary" size="medium" @click="jumpToPage('schoolSuite', {schoolId})">学校套件</el-button>
                </div>
            </div>
            <div class="right-panel">
                <div class="detail-container">
                    <div class="title">基础信息</div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校ID
                        </div>
                        <div class="detail-item__value">
                            {{detail.id}}
                        </div>
                    </div>

                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校名称
                        </div>
                        <div class="detail-item__value">
                            {{detail.name}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校全称
                        </div>
                        <div class="detail-item__value">
                            {{detail.fullName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校简称
                        </div>
                        <div class="detail-item__value">
                            {{detail.simpleName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校类型
                        </div>
                        <div class="detail-item__value">
                            {{!detail.type ? '' : parseToConstants(detail.type, 'schoolTypeConstants')}}
                        </div>
                    </div>

                    <div class="detail-item">
                        <div class="detail-item__title">
                            联系人
                        </div>
                        <div class="detail-item__value">
                            {{detail.managerName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            联系电话
                        </div>
                        <div class="detail-item__value">
                            {{detail.managerMobile}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            邮箱
                        </div>
                        <div class="detail-item__value">
                            {{detail.managerEmail}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            所属区域
                        </div>
                        <div class="detail-item__value">
                            {{detail.orgAreaName}}（{{detail.areaCode}}）
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            详细地址
                        </div>
                        <div class="detail-item__value">
                            {{detail.address}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            创办类型
                        </div>
                        <div class="detail-item__value">
                            {{['', '公办', '民办'][detail.isPublic]}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            组织机构代码
                        </div>
                        <div class="detail-item__value">
                            {{detail.orgCode}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            域名
                        </div>
                        <div class="detail-item__value">
                            {{detail.domainName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            加入时间
                        </div>
                        <div class="detail-item__value">
                            {{detail.accessDate | timeFormat}}
                        </div>
                    </div>

                    <div class="title">设置信息</div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            经销商
                        </div>
                        <div class="detail-item__value">
                            {{detail.bussinessName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            客户端类型
                        </div>
                        <div class="detail-item__value">
                            {{({
                            1: '企业微信',
                            2: '农行',
                            12: '企业微信及农行',
                            3: '建行生活',
                            4: '建行APP'
                            }[detail.clientType])}}
                        </div>
                    </div>
                    <div class="detail-item" v-if="detail.clientType == 1 || detail.clientType == 12 || detail.clientType == 4">
                        <div class="detail-item__title">
                            套件类型
                        </div>
                        <div class="detail-item__value">
                            {{['', '微校+老套件', '微校+新套件', '成长乐园', '成长乐园新'][detail.suiteType]}}
                        </div>
                    </div>


                    <template v-if="detail.clientType  == 1 || detail.clientType == 12 || detail.clientType == 4">
                        <div class="detail-item">
                            <div class="detail-item__title">
                                框架类型
                            </div>
                            <div class="detail-item__value">
                                {{({
                                1: '微校+',
                                4: '成长乐园',
                                }[detail.useNew])}}
                            </div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__title">
                                是否用新手机端页面
                            </div>
                            <div class="detail-item__value">
                                {{detail.isNewMobile == 1 ? '是' : detail.isNewMobile == 3 ? '自定义' : '否'}}
                            </div>
                        </div>
                        <div class="detail-item" v-if="detail.isNewMobile == 3">
                            <div class="detail-item__title">
                                自定义移动端首页地址
                            </div>
                            <div class="detail-item__value">
                                {{detail.mobileHomeUrl}}
                            </div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__title">
                                是否与企业微信同步
                            </div>
                            <div class="detail-item__value">
                                {{detail.syncForWx == 1 ? '是' : '否'}}
                            </div>
                        </div>
                        <div class="detail-item" v-if="detail.syncForWx == 1">
                            <div class="detail-item__title">
                                是否开启通讯录同步
                            </div>
                            <div class="detail-item__value">
                                {{detail.syncForWxAddress == 1 ? '是' : '否'}}
                            </div>
                        </div>
                        <div class="detail-item" v-if="detail.syncForWx == 1">
                            <div class="detail-item__title">
                                是否开启家校通讯录同步
                            </div>
                            <div class="detail-item__value">
                                {{detail.syncForWxAddressSchool == 1 ? '是' : '否'}}
                            </div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__title">
                                是否为新家校
                            </div>
                            <div class="detail-item__value">
                                {{detail.isExternalContact == 2 ? '是' : '否'}}
                            </div>
                        </div>
                    </template>
                    <template v-if="detail.clientType  == 2 || detail.clientType  == 3 || detail.clientType == 12 || detail.clientType == 4">
                        <div class="detail-item">
                            <div class="detail-item__title">
                                获客来源
                            </div>
                            <div class="detail-item__value">
                                {{detail.guestSource}}
                            </div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__title">
                                所属支行
                            </div>
                            <div class="detail-item__value">
                                {{detail.subBranch}}
                            </div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__title">
                                接入日期
                            </div>
                            <div class="detail-item__value">
                                {{detail.joinDate}}
                            </div>
                        </div>
                    </template>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校类型
                        </div>
                        <div class="detail-item__value">
                            {{{
                            1: '独立院校/园所',
                            2: '集团校/园所',
                            3: '分校/分园',
                            12: '农行学校'
                            }[detail.schoolType]}}
                        </div>
                    </div>

                    <div class="detail-item" v-if="detail.schoolType == 3">
                        <div class="detail-item__title">
                            所属总校/总园
                        </div>
                        <div class="detail-item__value">
                            {{detail.groupName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            订餐范围
                        </div>
                        <div class="detail-item__value">
                            {{detail.orderOrgAreaName}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            学校负责人
                        </div>
                        <div class="detail-item__value">
                            {{detail.liableNames}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            客户经理
                        </div>
                        <div class="detail-item__value">
                            {{detail.customerManager}}
                        </div>
                    </div>

                    <div class="title">开发信息</div>
                    <div class="detail-item" v-if="detail.clientType == 1 || detail.clientType == 12 || detail.clientType == 4">
                        <div class="detail-item__title">
                            企业号ID
                        </div>
                        <div class="detail-item__value">
                            {{detail.corpId}}
                        </div>
                    </div>
                    <div class="detail-item" v-if="detail.isNewWx == 1 && detail.clientType == 1">
                        <div class="detail-item__title">
                            企业corpid明文
                        </div>
                        <div class="detail-item__value">
                            {{detail.originalCorpId}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            授权code (有效期十分钟)
                        </div>
                        <div class="detail-item__value">
                            {{authCode}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            数据从中台下发
                        </div>
                        <div class="detail-item__value">
                            {{detail.platformSync == 1 ? '同步' : '不同步'}}
                        </div>
                    </div>
                    <div class="detail-item" v-if="detail.clientType == 1 || detail.clientType == 12 || detail.clientType == 4">
                        <div class="detail-item__title">
                            开启通讯录编辑权限
                        </div>
                        <div class="detail-item__value">
                            {{detail.addressBookPerm == 1 ? '开启' : '不开启'}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            第三方学校id
                        </div>
                        <div class="detail-item__value">
                            {{detail.thirdSchoolId}}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__title">
                            单点登录域名
                        </div>
                        <div class="detail-item__value">
                            {{detail.ssoDomainName}}
                        </div>
                    </div>

                    <div class="detail-item" v-if="detail.clientType == 1 || detail.clientType == 12 || detail.clientType == 4">
                        <div class="detail-item__title">
                            腾讯校园
                        </div>
                        <div class="detail-item__value">
                            {{['', '1.0', '2.0'][detail.tencentSchoolVersion]}}
                        </div>
                    </div>

                    <div class="title">图标及二维码</div>
                    <image-previewer tag="richtext" viewclass="image">
                        <div class="logo-list">
                            <div class="logo-item logo-item--square">
                                <img :src="detail.roundLogoUrl" class="logo-item__image"/>
                                <div class="logo-item__text">圆Logo</div>
                            </div>
                            <div class="logo-item logo-item--round">
                                <img :src="detail.squareLogoUrl" class="logo-item__image"/>
                                <div class="logo-item__text">长Logo</div>
                            </div>
<!--                            <div class="logo-item logo-item&#45;&#45;qrcode">-->
<!--                                <img :src="detail.wxqrcode" class="logo-item__image"/>-->
<!--                                <div class="logo-item__text">企业二维码</div>-->
<!--                            </div>-->
<!--                            <div class="logo-item logo-item&#45;&#45;qrcode" v-show="subscribeQrcode">-->
<!--                                <img :src="subscribeQrcode" class="logo-item__image"/>-->
<!--                                <div class="logo-item__text">学校通知二维码</div>-->
<!--                            </div>-->

                        </div>
                    </image-previewer>


                </div>
            </div>
        </div>
        <el-dialog @close="isShowTxSch = false" title="与腾讯智慧校园对接" :visible.sync="isShowTxSch" :close-on-press-escape='false'>
            <div>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="txSchClearStudentsFunc()">清空学生</el-button>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="setSubAccountFunc()">设置家长微信关注账号</el-button>
            </div>
        </el-dialog>
        <el-dialog @close="isShowyufan = false" title="与宇泛对接" :visible.sync="isShowyufan" :close-on-press-escape='false'>
            <div>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncAllDevice()">同步全部人脸设备</el-button>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncAllUser()">同步全部用户</el-button>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncAllFace()">同步用户人脸数据</el-button>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncAllAuthDevice()">同步全部设备用户授权</el-button>
                <!-- <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncOneAuthDevice()">同步单个设备用户授权</el-button> -->
            </div>
        </el-dialog>
         <el-dialog @close="isShowkedaxunfei = false" title="与科大讯飞对接" :visible.sync="isShowkedaxunfei" :close-on-press-escape='false'>
            <div>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncDept()">同步组织</el-button>
                <el-button style="width: 180px;margin-bottom: 10px;" type="primary" size="medium" @click.native="syncUser()"> 同步用户</el-button>
            </div>
        </el-dialog>
        <el-dialog @close="isShowHaikang = false" title="与海康对接" :visible.sync="isShowHaikang" :close-on-press-escape='false'>
            <div>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="haikangInitDepartFunc()">同步教师部门</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="haikangInitClassFunc()">同步班级</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="haikangInitTeacherFunc()">同步教师数据</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="haikangInitStutentFunc(false)">同步学生数据</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="haikangInitParentFunc()">同步家长数据</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="haikangInitFaceFunc()">同步人脸</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="synCardInfoToHaiKang(2)">同步教师卡</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="synCardInfoToHaiKang(1)">同步学生卡</el-button>
                   <div style="margin-bottom: 10px;">
                    <el-row :gutter="20">
                        <el-col :span="10"><el-input  size="medium" v-model="newgradeCode" placeholder="请输入指定年级编码"></el-input><div class="grid-content bg-purple"></div></el-col>
                        <el-col :span="10"><el-input  size="medium" v-model="newclassCode" placeholder="请输入指定班级编码"></el-input><div class="grid-content bg-purple"></div></el-col>
                    </el-row>                    
                </div>
            </div>
        </el-dialog>
        <el-dialog @close="isShowJD = false" title="与焦点对接" :visible.sync="isShowJD" :close-on-press-escape='false'>
            <div>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncDepartFunc()">与焦点同步部门</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncUserFunc()">与焦点同步用户</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncGradeFunc()">与焦点同步年级</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncClazzFunc()">与焦点同步班级</el-button>
                
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncHeadermasterFunc()">与焦点同步班主任</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncSubjectFunc()">与焦点同步科目</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncTsSubjectFunc()">与焦点同步任课信息</el-button>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateParentExternalUserIdFunc()">设置家长微信关注账号</el-button>

            </div>
            <div>
                <div style="margin-bottom: 10px;">
                    <el-row :gutter="20">
                        <el-col :span="10"><el-input  size="medium" v-model="gradeCode" placeholder="请输入指定年级编码"></el-input><div class="grid-content bg-purple"></div></el-col>
                        <el-col :span="10"><el-input  size="medium" v-model="classCode" placeholder="请输入指定班级编码"></el-input><div class="grid-content bg-purple"></div></el-col>
                    </el-row>                    
                </div>
                <el-button style="width: 160px;margin-bottom: 10px;" type="primary" size="medium" @click.native="updateSyncStudentAndParentFunc()">与焦点同步学生家长</el-button>
            </div>
        </el-dialog>
        <el-dialog @close="datamsg = ''" title="与焦点同步学生家长返回信息" :visible.sync="newisShowError" :close-on-press-escape='false'>
            <div class="error-msg-container" v-html="datamsg">
            </div>
        </el-dialog>

      
        <el-dialog @close="errorMsg = ''" title="错误信息" :visible.sync="isShowError" :close-on-press-escape='false'>
            <div class="error-msg-container" v-html="errorMsg">
            </div>
        </el-dialog>
         <el-dialog :title="mynum==1?'批量同步到农行返回信息':'取消农行同步返回信息'" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="mypop" width="700px" :lock-scroll="false" :modal-append-to-body='false'>

        <div class="error-msg-container" v-html="mydata">
            </div>
        <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="mypop = false">确 定</el-button>
                </span>
      </el-dialog>

       <el-dialog title="批量删除账号" :visible.sync="dialogImportTeacherVisible" :close-on-press-escape='false' :close-on-click-modal='false' :modal-append-to-body='false' >
            <div class="bs-callout bs-callout-danger" id="callout-glyphicons-dont-mix">
              <div class="title">批量删除家长账号说明：</div>              
              <div class="info-title">1、导入模板：手机号放在第一列，后台从第二行开始读取；</div>
              <div class="info-title">2、此操作会同步到第三方（企微、农行等），请谨慎操作；</div>
              <div class="info-title">3、导入操作后，返回结果。如有失败用户，可下载之后修改再次导入。</div>
            </div>
           <div class="sns-btn-div">
              <el-upload class="upload-import"  name='file' :action="uploadPath" :data="uploadData" :show-file-list='false' accept=".xls" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" >
               <el-button type="primary" :loading="importLoading" >{{btnText}}</el-button>
              </el-upload>
           </div>
           <div v-show="resultShow" class="bs-callout bs-callout-warning" id="callout-glyphicons-dont-mix2">
              <div class="title">导入结果：</div>
              <div class="info-title">成功导入：{{sucessUserCount}}条</div>
              <div class="info-title">导入失败：{{errorUserCount}}条
                 <a v-if="errorUserCount>0" target= "_blank" :href="downloadErroUrl" download="下载失败名单">
                    <el-button type="text">下载失败名单</el-button>
                  </a>
              </div>
            </div>
           <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogImportTeacherVisible=false">关 闭</el-button>
          </span>
        </el-dialog>



    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import baseMixin from '@/mixins/baseMixin';
    import mixin from "@/mixins/windowResize";
    import {
        querySchoolDetail,
        queryAuthCode,
        initOutsideSchoolUserDepart,
        initSchoolFellowDepart,
        initNewGradeAndClass,
        initDepartCode,
        restNoSetPasswordUser,
        updatePlatformOrganization,
        querySubscribeQrcode,
        updateSyncStudentAndParent,
        updateSyncClazz,
        updateSyncGrade,
        updateSyncUser,
        updateSyncDepart,
        syncTeacherFromEdu,
        haikangInitTeacher,
        haikangInitDepart,
        haikangInitClass,
        haikangInitStutent,
        haikangInitParent,
        synCardInfoToHaiKang,
        haikangInitFace,
        synchSchUserList,
        updateSyncHeadermaster,
        updateSyncSubject,
        updateSyncTsSubject,
        updateParentExternalUserId,
        clearAllStudent,
        updateParentExternalUserIdTx,
        update2StandardGrade,
        updateSysnCancel,updateSysn,
        syncOneAuthDevice,syncAllAuthDevice,syncAllFace,syncAllUser,syncAllDevice,batchOpnResult,syncUser,syncDept 
    } from '@/api/schoolManage';
    import {parseToConstants, isShowByPermission} from '@/utils/utils';

    export default {
        name: 'schoolDetail',
        components: {ImagePreviewer},
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        mixins: [baseMixin,mixin],
        computed: {
            exportUrl() {
                return `${global.command === 'production' ? 'https://wyms.weixiaojia.cn/wyms' : 'http://wyms.weixiaojia.net/wyms'}/school/exportDifferenceFromEdu?schoolId=${this.schoolId}&token=${this.$store.getters.token}`;
            }
        },
        data() {
            return {
                dialogImportTeacherVisible:false,
                importLoading: false,
                errInfo: "",
                uploadPath: global.wyms + "schoolUser/batchOpn",
                uploadData: {
                     schoolId: this.$route.query.schoolId,
                     token: this.$store.getters.token,
                     opnType:1,
                     opnUserType:3
                },
                errorUserCount:0,
                totalUserCount:0,
                sucessUserCount:0,
                downloadUrl:'',
                downloadErroUrl:'',
                resultShow:false,
                    btnText: '选择导入文件',
                schoolId: this.$route.query.schoolId,
                detail: {},
                authCode: '',
                subscribeQrcode: '',
                isShowTxSch: false,
                isShowHaikang: false,
                isShowyufan:false,
                isShowkedaxunfei:false,
                isShowJD: false,
                errorMsg: '',
                isShowError: false,
                newisShowError:false,
                mypop:false,
                mydata:"",
                mynum:1,
                classCode:"",
                gradeCode:"",
                newclassCode:"",
                newgradeCode:"",
                datamsg:""
            }
        },
        created() {
            querySchoolDetail({
                schoolId: this.schoolId
            })
                .then(data => {
                    this.detail = data;
                });
            queryAuthCode({
                schoolId: this.schoolId
            })
                .then(data => {
                    this.authCode = data.authCode;
                });
            querySubscribeQrcode({
                schoolId: this.schoolId
            })
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        this.subscribeQrcode = data.data.qrcode_middle;
                    }
                });

        },
        methods: {
             beforeAvatarUpload(file) {
      let suffix = file.name.split(".")[file.name.split(".").length - 1];
      if (suffix != "xls") {
        this.$message.error("请上传.xls文件!");
      } else {
         this.importLoading = true;
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
          this.batchOpnResult(res.data.importMarkId);
      }else{
         this.importLoading = false;
         this.$message.error(res.msg);
      }
    },
      batchOpnResult(importMarkId) {
        let self = this;
          batchOpnResult(importMarkId).then(res => {
              let data = res;
              if (data) {
                //   this.totalUserCount=data.data.total
                  let currCount = data.succeedCount ? data.succeedCount : 0;
                  if (!data.processed) {
                      this.btnText = '已处理'+currCount;
                      setTimeout(() => {
                          self.batchOpnResult(importMarkId);
                      }, 2000);
                  } else {
                      this.btnText = '选择导入文件';
                      this.errorUserCount = data.failList.length;
                      this.sucessUserCount = data.succeedCount;
                      this.downloadResultXls(importMarkId);
                       this.importLoading = false;
                       this.resultShow=true;
                  }
              } else {
                  this.importLoading = false;
              }
          }).catch(res => {
              this.importLoading = false;
          });
      },
        downloadResultXls(importMarkId) {
            this.downloadErroUrl=global.wyms +'schoolUser/batchOpnResultDownload?importMarkId='+importMarkId+'&token=' +this.$store.getters.token;
            
        },
            isShowByPermission,
            parseToConstants,
            transStandardGradeFunc() {
                update2StandardGrade({
                    schoolId: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        console.log(data);
                        if(data.result) {
                            this.$message.success('转换成功')
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
            },
            showErrorMsg(errorMsg) {
                this.errorMsg = errorMsg;
                this.isShowError = true;
            },
            newshowErrorMsg(datamsg) {
                this.datamsg = datamsg;
                this.newisShowError = true;
            },
            synchSchUserList(company) {
                synchSchUserList({
                    company,
                    schoolId: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        console.log(data);
                        if(data.result) {
                            this.$message.success('同步成功')
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
            },
            updateSyncStudentAndParentFunc() {
                updateSyncStudentAndParent({
                    schoolId: this.schoolId,
                    classCode:this.classCode,
                    gradeCode:this.gradeCode

                }).then(res => res.data)
                    .then(data => {
                         this.classCode="",
                        this.gradeCode="";
                        this.isShowJD=false;
                        if(data.result) {
                                    this.newshowErrorMsg(data.data);
                                }else{
                                    this.newshowErrorMsg(data.msg);
                                }
                        // if(data.result) {
                        //     this.$message.success('同步成功')
                        // } else {
                        //     this.$message.error(data.msg);
                        // }
                    })
            },
            updateSyncClazzFunc() {
                updateSyncClazz({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                                 if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            updateSyncGradeFunc() {
                updateSyncGrade({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                              if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            syncOneAuthDevice() {
                syncOneAuthDevice({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('同步完成')
                    })
            },
            syncAllAuthDevice() {
                syncAllAuthDevice({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('同步完成')
                    })
            },
            syncAllFace() {
                syncAllFace({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('同步完成')
                    })
            },
            syncAllUser() {
                syncAllUser({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('同步完成')
                    })
            },
            syncAllDevice() {
                syncAllDevice({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('同步完成')
                    })
            },   
            syncUser() {
                 syncUser({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                                if(data.code==200) {
                                    this.newshowErrorMsg(data.data)
                                }  else {
                            this.$message.error(data.msg);
                        }
                            })
            },    
            syncDept() {
                 syncDept({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                                if(data.code==200) {
                                    this.newshowErrorMsg(data.data)
                                }  else {
                            this.$message.error(data.msg);
                        }
                            })
            },         
            updateSyncUserFunc() {
                updateSyncUser({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                               if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            updateSyncDepartFunc() {
                updateSyncDepart({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                                 if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            updateSyncHeadermasterFunc() {
                updateSyncHeadermaster({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                                  if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            updateSyncSubjectFunc() {
                updateSyncSubject({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                              if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            updateSyncTsSubjectFunc() {
                updateSyncTsSubject({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                               if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            updateParentExternalUserIdFunc() {
                updateParentExternalUserId({
                    schoolId: this.schoolId
                }).then(res => res.data).then(data => {
                               if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
            },
            initOutsideSchoolUserDepartFunc() {
                this.$confirm('是否初始化校外部门？', '初始化', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    initOutsideSchoolUserDepart({
                        schoolId: this.schoolId
                    })
                        .then(() => {
                            this.$message.success('初始化校外部门成功')
                        });
                });

            },
            initSchoolFellowDepartFunc() {
                this.$confirm('是否初始化校友部门？', '初始化', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    initSchoolFellowDepart({
                        schoolId: this.schoolId
                    })
                        .then(() => {
                            this.$message.success('初始化校友部门成功')
                        });
                });

            },
             updateSysn() {
                this.$confirm('是否批量同步到农行？', '批量同步到农行', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    updateSysn({
                        schoolId: this.schoolId
                    })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                           this.mydata=data.data;
                           this.mypop=true;
                           this.mynum=1
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
             updateSysnCancel() {
                this.$confirm('是否取消农行同步？', '取消农行同步', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    updateSysnCancel({
                        schoolId: this.schoolId
                    }).then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.mydata=data.data;
                            this.mypop=true;
                            this.mynum=2
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            initNewGradeAndClassFunc() {
                this.$confirm('是否初始化新生班级？', '初始化', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    initNewGradeAndClass({
                        schoolId: this.schoolId
                    })
                        .then(() => {
                            this.$message.success('初始化新生班级成功')
                        });
                });
            },
            initDepartCodeFunc() {
                this.$confirm('是否初始化班级编码？', '初始化', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    initDepartCode({
                        schoolId: this.schoolId
                    })
                        .then(() => {
                            this.$message.success('初始化班级编码成功')
                        });
                });
            },
            restNoSetPasswordUserFunc() {
                this.$confirm('初始化学生登录密码？', '初始化', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    restNoSetPasswordUser({
                        schoolId: this.schoolId
                    })
                        .then(() => {
                            this.$message.success('初始化学生登录密码成功')
                        });
                });
            },
            updatePlatformTeacherFunc() {
                this.$confirm('将以政务系统为准，创建所有老师账号（过程可能比较缓慢），是否继续？', '读取', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    if(!this.detail.orgCode) {
                        this.$message.error('学校未设置组织机构码！')
                    } else {
                        syncTeacherFromEdu({
                            schoolId: this.schoolId,
                        }).then(res => res.data).then(data => {
                                if(data.result) {
                                    this.showErrorMsg(data.data);
                                }else{
                                    this.showErrorMsg(data.msg);
                                }
                            })
                            // .then(() => {
                            //     this.$message.success('读取成功')
                            // });
                    }

                });

            },
            exportTeacherData() {
                updatePlatformOrganization({
                    schoolId: this.schoolId,
                    orgCode: this.detail.orgCode,
                    postCode: this.detail.postcode,
                })
                    .then(data => {
                        console.log(data)
                    });
            },
            haikangInitParentFunc() {
                haikangInitParent({
                    schoolId: this.schoolId,
                    targetClassCode:this.newclassCode,
                    targetGradeCode:this.newgradeCode,
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            synCardInfoToHaiKang(cardType) {
                synCardInfoToHaiKang(this.schoolId,cardType)
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            haikangInitFaceFunc() {
                haikangInitFace({
                    schoolId: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            haikangInitStutentFunc(reSync) {
                haikangInitStutent({
                    schoolId: this.schoolId,
                    targetClassCode:this.newclassCode,
                    targetGradeCode:this.newgradeCode,
                    reSync:reSync
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            haikangInitTeacherFunc() {
                haikangInitTeacher({
                    schoolId: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            haikangInitDepartFunc() {
                haikangInitDepart({
                    schoolId: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            haikangInitClassFunc() {
                haikangInitClass({
                    schoolId: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.showErrorMsg(data.msg);
                        }
                    })
            },
            txSchClearStudentsFunc() {
                clearAllStudent({ schoolId: this.schoolId })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message.success(data.msg);
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            setSubAccountFunc() {
                updateParentExternalUserIdTx({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('同步完成')
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";
     .sns-btn-div {
        height: 80px;
        padding-left: 20px;
        padding-top: 20px;
    }

    .left-panel {
        position: relative;
        float: left;
        width: 260px;
        margin-left: 200px;
    }

    .right-panel {
        float: left;
    }

    .title {
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;

        &:not(:first-of-type) {
            margin-top: 40px;
        }
    }

       .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .body{
      overflow: auto;
      padding-top:10px;
  }

    .left-panel-btn-item {
        margin: 10px 0;
    }

    .detail-item {
        margin: 20px 0;

        & > * {
            display: inline-block;
        }
    }

    .detail-item__title {
        width: 200px;
    }

    .detail-item__value {
        padding-left: 16px;
        width: 500px;
        color: #909399;

    }

    .logo-list {
        margin-top: 20px;
        background: #ccc;
        padding: 10px;

        & > * {
            @include middleIB;
        }

        .logo-item {
            text-align: center;
            margin-right: 10px;
            font-size: 14px;

            img {
                height: 100px;
            }
        }
    }

    @media screen and (max-width: 1600px) {
        .left-panel {
            margin-left: 100px;
        }
    }

    @media screen and (max-width: 1450px) {
        .left-panel {
            margin-left: 40px;
            width: 200px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolDetail.vue